<template>
  <div class="type" :class="[type]">{{ typeText }}</div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const typeText = computed(() =>
      props.type === 'action' ? 'Акция' : 'Промокод'
    );
    return {
      typeText,
    };
  },
});
</script>

<style lang="scss" scoped>
.type {
  @include fz(12, 16);
  border-radius: 100px;
  font-weight: 400;
  padding: 2px 8px;
  background: $white;

  &.promocode {
    color: $orange_promo;
  }

  &.action {
    color: $purple;
  }
}
</style>
